<template>
  <!-- 게시판 추가 등록 -->
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="게시판 기본 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="게시판 공개 여부">
                  <lp-radio @onSelect="res => value.activate_board = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.activate_board"
                            :data="[{label:'공개',value:true},{label:'비공개',value:false}]"
                            type="small"></lp-radio>
                </admin-form-item>

                <admin-form-item label="게시판 카테고리" desc="게시판 추가 > 전체 게시판 설정 > 게시판 카테고리 관리메뉴에 등록된 카테고리 중 해당 게시판이 노출될 카테고리를 선택합니다.">
                  <lp-radio @onSelect="res => value.activate_category = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.activate_category"
                            :data="[{label:'사용',value:true},{label:'미사용',value:false}]"
                            type="small"></lp-radio>
                  <lp-adm-drop-input ref="adminput_board"
                                     :data.sync="catArr1"
                                     :selectVal="selectedCategory(value.category1_id, 'cat1')"
                                     @onSelect="res=>clickCategory(res.value, 'cat1')"
                                     :placeholder="selectedCategory(value.category1_id, 'cat1')"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;margin-top:12px"
                                     v-if="value.activate_category"></lp-adm-drop-input>
                </admin-form-item>
                <!--<admin-form-item label="게시판 카테고리*">
                  <div class="columns is-multiline">
                    <div class="column is-full">
                     <lp-adm-drop-input ref="adminput_board"
                                         :data.sync="cat2"
                                         :selectVal="selectedCategory(value.category2_id, 'cat2')"
                                         @onSelect="res=>clickCategory(res.value, 'cat2')"
                                         :placeholder="selectedCategory(value.category2_id, 'cat2')"
                                         width="160px"
                                         listAlign="center"
                                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                      <lp-adm-drop-input ref="adminput_board"
                                         :data.sync="cat3"
                                         :selectVal="selectedCategory(value.category3_id, 'cat3')"
                                         @onSelect="res=>clickCategory(res.value, 'cat3')"
                                         :placeholder="selectedCategory(value.category3_id, 'cat3')"
                                         width="160px"
                                         listAlign="center"
                                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                    </div>
                  </div>
                </admin-form-item>-->
              </div>
              <div class="column is-7">
                <admin-form-item label="게시판명*">
                  <input class="input"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text"
                         maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-7">
                <admin-form-item label="게시판 한줄 설명">
                  <input class="input"
                         :value="value.sub_title"
                         @input="e=> value.sub_title = e.target.value"
                         type="text"
                         maxlength="50">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시판 대표 이미지">
                  <input-img :url.sync="value.img"></input-img>
                </admin-form-item>
              </div>
              <!--<div class="column is-7">
                <admin-form-item label="게시판 타입">
                  <lp-sort-drop-down :list="board_type_list" @onSelect="selBoardType" width="140" :placeholder="boardType"></lp-sort-drop-down>
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="게시판 접근 권한 설정">
            <div class="columns is-multiline">
              <div class="column is-7">
                <admin-form-item label="회원">
                  <div class="grid-box" style="width:200px">
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_user.write"
                                   label="글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_user.read"
                                   label="글 보기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_user.comment"
                                   label="댓글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_user.comment_read"
                                   label="댓글 보기"></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-7">
                <admin-form-item label="파트너">
                  <div class="grid-box" style="width:200px">
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_partner.write"
                                   label="글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_partner.read"
                                   label="글 보기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_partner.comment"
                                   label="댓글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_partner.comment_read"
                                   label="댓글 보기"></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-7">
                <admin-form-item label="비회원">
                  <div class="grid-box" style="width:200px">
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_guest.write"
                                   label="글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_guest.read"
                                   label="글 보기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_guest.comment"
                                   label="댓글 쓰기"></lp-check-bool>
                    <lp-check-bool class="col-6" style="margin-bottom:8px" :checked-val.sync="value.permission_guest.comment_read"
                                   label="댓글 보기"></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="게시판 기능 설정">
            <div class="columns is-multiline">
              <div class="column is-7">
                <admin-form-item label="작성자 표시 방법">
                  <!--<lp-radio @onSelect="res => value.show_author = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.show_author"
                            :data="author_arr"
                            type="small"></lp-radio>
-->
                  <lp-sort-drop-down :list="author_arr" @onSelect="selAuthor" width="140" :placeholder="AuthorName"></lp-sort-drop-down>
                </admin-form-item>
              </div>

              <div class="column is-7">
                <admin-form-item label="댓글/답변 기능 선택" :tip="answerTip">
                  <lp-radio @onSelect="res => selectedAnswer = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="selectedAnswer"
                            :data="answer_arr"
                            type="small"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-7">
                <admin-form-item label="공유 기능 사용 여부" tip="해당 게시물을 SNS에 공유할 수 있습니다.">
                  <lp-radio @onSelect="res => value.activate_share = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.activate_share"
                            :data="enable_arr"
                            type="small"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-7">
                <admin-form-item label="말머리 기능 사용여부" tip="사용시에 [ 추가하기 ] 버튼을 통해서 구분명 생성 필드를 만들 수 있습니다. ">
                  <lp-radio @onSelect="res => value.activate_classification = res"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.activate_classification"
                            :data="[{ label: '사용함', value: true }, { label: '사용안함', value: false }]"
                            type="small"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-7" v-if="value.activate_classification">
                <div class="columns is-multiline">
                  <div class="column flex">
                    <div style="color: #363636; display: block; line-height: 28px; font-weight: 700; margin-right: 8px; font-size: 0.9rem">말머리 추가</div>
                    <button class="button is-primary" @click="addFields">추가하기</button>
                  </div>
                </div>
                <div v-for="(field,idx) in value.fields"
                     :key="'field-'+idx"
                     class="flex" style="margin-bottom:8px">
                  <input class="input"
                         style="width:300px"
                         :value="field"
                         @input="e=>inputFields(e, idx)"
                         type="text" maxlength="20">
                  <div @click="delFields(idx)" class="unselect" style="margin-left:8px">
                    <i class="material-icons" style="line-height: 32px">close</i>
                  </div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

  </div>
</template>

<script>
  import moment from "moment";
  import Datepicker from "vuejs-datepicker";
  import InputImg from "../../module/common/InputImg";
  import LpSelect from "../../module/common/LpSelect.vue";
  import TimeInfo from "../../module/common/TimeInfo.vue";
  import LpInputText from "../../module/common/LpInputText";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpAddress from "../../module/common/LpAddress";
  import LpRadio from "../../module/common/LpRadio";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    layout: "Main",
    components: {
      LpCheckBool,
      InputImg,
      LpSelect,
      TimeInfo,
      Datepicker,
      LpInputText,
      LpSortDropDown,
      LpAddress,
      LpRadio,
      LpAdmDropInput
    },
    mixins: [
      CreateMixin
    ],
    created() {
      this.getData();
    },
    data() {
      return {
        answerTip: '댓글은 모든 유저가 댓글 및 대댓글을 남길 수 있고 답변은 관리자만 답변의 형식으로 댓글을 남길 수 있는 기능입니다.',
        selectedAnswer: 'comment',
        value: {
          category1_id:'',
          category2_id:'',
          category3_id:'',
          show_author: 0,
          id: '',
          title: '',
          sub_title: '',
          type: '',
          // 게시판 기능 설정
          activate_category: true,
          activate_board: true,
          activate_comment: true,
          activate_reply: false,
          activate_share: true,
          // 말머리 기능 사용여부
          activate_classification: false,
          // 구분명 max 5개
          fields: [''],
          // 기능 허용
          permission_partner: {
            comment: true,
            comment_read: true,
            write: true,
            read: true
          },
          permission_user: {
            comment: true,
            comment_read: true,
            write: true,
            read: true
          },
          permission_guest: {
            comment: true,
            comment_read: true,
            write: true,
            read: true
          }
        },
        // 활성화 부분
        answer_arr: [
          { label: '댓글', value: 'comment' },
          { label: '답변', value: 'reply' }
        ],
        enable_arr:[
          { label: '사용', value: true },
          { label: '미사용', value: false }
        ],
        // 작성자 부분
        author_arr:[
          { label: '익명', value: 0 },
          { label: 'ID', value: 1 },
          { label: '실명', value: 2 },
          // { label: '닉네임', value: 3 },
          // { label: '이름(id)', value: 4 },
          // { label: '닉네임(id)', value: 5 }
        ],
        // 게시판 타입 리스트
        board_type_list:[
          { label: '공지사항', value: 'notice' },
          { label: '이벤트', value: 'event' },
          { label: '질문', value: 'faq' },
          { label: '기타', value: 'extra' },
        ],
        author_label:'',
        board_label:'',
        // 카테고리
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: []
      }
    },
    computed: {
      AuthorName(){
        for(let i=0; i<this.author_arr.length; i++){
          if(this.author_arr[i].value === this.value.show_author){
            return this.author_arr[i].label;
            break;
          }
        }
      },
      boardType(){
        for(let i=0; i<this.board_type_list.length; i++){
          if(this.board_type_list[i].value === this.value.type){
            return this.board_type_list[i].label;
            break;
          }
        }
      }
    },
    watch:{
      selectedAnswer(n) {
        if(n==='comment') {
          this.value.activate_comment = true;
          this.value.activate_reply = false;
        } else {
          this.value.activate_comment = false;
          this.value.activate_reply = true;
        }
      },
      // 'value.activate_comment'(n) {
      //   this.value.activate_reply = n;
      // },
      'value.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'value.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n);
      }
    },
    methods: {
      inputFields(e, idx){
        this.value.fields[idx] = e.target.value;
      },
      addFields(){
        if (this.value.fields.length<5) this.value.fields.push('');
      },
      delFields(idx){
        removeIndex(this.value.fields,idx);
      },
      // 작성자 선택
      selAuthor(res){
        this.value.show_author = res;
      },
      // 게시판 타입 선택
      selBoardType(res){
        this.value.type = res;
      },
      done() {
        let board = this.value;
        let err = ''
        if (board.title==='') err='게시판명을 입력해주세요.';
        if (board.activate_category && !board.category1_id) err='카테고리를 선택해주세요.';
        //if (this.setting.show_author==='') err='작성자 표시 부분 선택하세요.'

        if(err!==''){
          this.toast(err)
          return
        }
        this.$store.commit('setLoading', true);
        if (this.$route.query.id){
          this.$axios.patch(this.getUrl('board/'+this.$route.query.id), this.value).then(res=>{
            if (res.status===200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.')
              this.$router.replace(this.getPath('board'));
              this.$root.$emit('menus');
            }
          }).catch(error => {
            this.$store.commit('setLoading', false);
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          });
        }
        else{
          this.$axios.post(this.getUrl('board'), this.value).then(res=>{
            if (res.status===200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.')
              this.$router.replace(this.getPath('board'));
              this.$root.$emit('menus');
            }
          }).catch(error => {
            this.$store.commit('setLoading', false);
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          });
        }
      },
      getData(){
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('board/'+this.$route.query.id)).then(res=>{
            this.value = res.data;

            if(this.value.activate_reply) {
              this.selectedAnswer = 'reply';
            } else if(this.value.activate_comment) {
              this.selectedAnswer = 'comment';
            }
          });
        }
        this.getCats();
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('board/category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat(this.catArr2, this.value.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.value.category2_id);
          });
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.value.category1_id = value;
          this.value.category2_id = '';
          this.value.category3_id = '';
          this.selectedPack = '';
        }
        else if (type === 'cat2') {
          this.value.category2_id = value;
          this.value.category3_id = '';
        }
        else if (type === 'cat3') {
          this.value.category3_id = value;
        }
      },
      selectedCategory(cat_id, type) {
        if (type === 'cat1' && cat_id) {
          for(let i=0; i<this.catArr1.length; i++) {
            if (this.catArr1[i].value === cat_id){
              return this.catArr1[i].label;
              break;
            }
          }
        }
        else if (type === 'cat2' && cat_id) {
          for(let j=0; j<this.cat2.length; j++) {
            if (this.cat2[j].value === cat_id){
              return this.cat2[j].label;
              break;
            }
          }
        }
        else if (type === 'cat3' && cat_id) {
          for(let x=0; x<this.cat3.length; x++) {
            if (this.cat3[x].value === cat_id){
              return this.cat3[x].label;
              break;
            }
          }
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  //@import '~assets/css/lp_main';

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between


  .event-comment-content
    padding 20px
    font-size 0.95rem
    color #222
    border-radius 3px
    border none
    background-color #f2f7f8
    display block
    width 100%
    height 120px


  .btn-add-img
    margin 0 8px 8px 0
    background #f2f7f8
    width 80px
    height 80px
    text-align center


  .btn-add-img i
    font-size 3rem
    line-height 80px
    color #555


  .checkmark
    position absolute
    top 0
    left 0
    height 25px
    width 25px
    background-color #eee


  .lp-permission-checkbox > label
    font-size 0.8rem
    margin-right 8px

  .checkbox-label
    font-size: 0.83rem

</style>
